import {Component, Input, OnInit} from "@angular/core";
import {DataService} from "@app/shared/data.service";

@Component({
  selector: "app-breadcrumbs",
  templateUrl: "./breadcrumbs.component.html",
  styleUrls: ["./breadcrumbs.component.scss"],
})
export class BreadcrumbsComponent implements OnInit {
  @Input() items: {link: string, title: string, subTitle: string}[] = [];
  title: string = "";
  breadcrumbs: { title: string, link: string }[] = [];

  constructor(
      public dataService: DataService
  ) {}

  ngOnInit(): void {
    this.dataService.breadcrumbsArray.subscribe((data) => {
      this.breadcrumbs = [...data];
    })
  }
}
